function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo } from 'react';
import Decimal from 'decimal.js';
import { useFormContext } from 'react-hook-form';
import { Column, Row, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { BundlePriceEditorContent } from "../../../../../components/BundlePriceEditor";
import DiscountInput from "../../../../../components/ServiceCreation/ServiceBuilder/DiscountInput";
import MinPriceTextField from "../../../../../components/ServiceCreation/ServiceBuilder/MinPriceTextField";
import PriceTextField from "../../../../../components/ServiceCreation/ServiceBuilder/PriceTextField";
import PricingTextField from "../../../../../components/ServiceCreation/ServiceBuilder/PricingTextField";
import { getPriceAfterDiscount } from "../../../../../components/ServiceCreation/ServiceBuilder/ServiceBuilder.utils";
import { useFeatureFlags } from "../../../../../hooks/useFeatureFlags";
import { DiscountModel, DiscountType, serviceModel } from "../../../../../models";
import { ServiceCostType } from "../../../../../models/service-cost";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GetServiceRateModalContentTID = parentTestId => getTestIds(parentTestId);
export const ServiceRateModalContent = _ref => {
  let {
    service,
    draft,
    setDraft,
    testid
  } = _ref;
  const {
    SERVICE_TEMPLATE_BUNDLE,
    START_BILLING_AT_PHASE_2_INLINE
  } = useFeatureFlags();
  const isBundle = Boolean(SERVICE_TEMPLATE_BUNDLE && serviceModel.isBundle(service));
  const {
    watch
  } = useFormContext();
  const [pricing, price, minPrice, discount] = watch(['pricing', 'price', 'minPrice', 'discount']);
  const discountedPrice = useMemo(() => getPriceAfterDiscount({
    pricing,
    price,
    minPrice,
    discount
  }), [pricing, price, minPrice, discount]);
  const changeService = transformer => {
    setDraft(draft.setService(service.id, transformer));
  };
  const serviceData = useMemo(() => draft.service(service.id), [draft, service.id]);
  if (isBundle) {
    var _serviceData$bundle;
    return /*#__PURE__*/_jsx(BundlePriceEditorContent, {
      service: service,
      showActions: false,
      data: {
        bundleRate: (serviceData === null || serviceData === void 0 ? void 0 : serviceData.cost.pricingType) === ServiceCostType.Fixed || (serviceData === null || serviceData === void 0 ? void 0 : serviceData.cost.pricingType) === ServiceCostType.Variable ? (serviceData === null || serviceData === void 0 ? void 0 : serviceData.cost.price.toNumber()) || 0 : 0,
        discount: serviceData !== null && serviceData !== void 0 && serviceData.cost.discount ? serviceData === null || serviceData === void 0 ? void 0 : serviceData.cost.discount.amount().toNumber() : '',
        discountType: serviceData !== null && serviceData !== void 0 && serviceData.cost.discount ? serviceData === null || serviceData === void 0 ? void 0 : serviceData.cost.discount.type() : DiscountType.Percent,
        includedServiceRates: (serviceData === null || serviceData === void 0 || (_serviceData$bundle = serviceData.bundle) === null || _serviceData$bundle === void 0 ? void 0 : _serviceData$bundle.services.reduce((acc, s) => {
          acc[s.serviceTemplateId || ''] = +s.rate;
          return acc;
        }, {})) || {}
      },
      onDataChange: _ref2 => {
        let {
          bundleRate,
          discount,
          discountType,
          includedServiceRates
        } = _ref2;
        return changeService(s => {
          var _serviceData$bundle2;
          return _objectSpread(_objectSpread({}, s), {}, {
            cost: _objectSpread(_objectSpread({}, s.cost), {}, {
              price: new Decimal(bundleRate),
              discount: +discount >= 0 ? DiscountModel.make(discountType, +discount) : null
            }),
            bundle: _objectSpread(_objectSpread({}, s.bundle), {}, {
              services: (serviceData === null || serviceData === void 0 || (_serviceData$bundle2 = serviceData.bundle) === null || _serviceData$bundle2 === void 0 ? void 0 : _serviceData$bundle2.services.map(bs => _objectSpread(_objectSpread({}, bs), {}, {
                rate: new Decimal(includedServiceRates[bs.serviceTemplateId || ''])
              }))) || []
            })
          });
        });
      }
    });
  }
  const testIds = useMemo(() => GetServiceRateModalContentTID(testid), [testid]);
  return /*#__PURE__*/_jsxs(Column, {
    gap: 16,
    "data-testid": testIds.ServiceRateModalContentTestIds.Root(),
    children: [START_BILLING_AT_PHASE_2_INLINE && /*#__PURE__*/_jsx(PricingTextField, {}), (() => {
      const Wrapper = START_BILLING_AT_PHASE_2_INLINE ? Row : Column;
      const gap = START_BILLING_AT_PHASE_2_INLINE ? 8 : 16;
      return /*#__PURE__*/_jsxs(Wrapper, {
        gap: gap,
        children: [pricing === 'range' && /*#__PURE__*/_jsx(MinPriceTextField, {
          testid: "edit-service-rate-modal-min-price",
          onChange: value => changeService(s => _objectSpread(_objectSpread({}, s), {}, {
            cost: _objectSpread(_objectSpread({}, s.cost), {}, {
              minPrice: new Decimal(value || 0)
            })
          }))
        }), /*#__PURE__*/_jsx(PriceTextField, {
          testid: "edit-service-rate-modal-price",
          onChange: value => changeService(s => _objectSpread(_objectSpread({}, s), {}, {
            cost: _objectSpread(_objectSpread({}, s.cost), pricing === 'range' ? {
              maxPrice: new Decimal(value || 0)
            } : {
              price: new Decimal(value || 0)
            })
          }))
        }), /*#__PURE__*/_jsx(DiscountInput, {
          testid: "edit-service-rate-modal-discount",
          onChange: value => changeService(s => _objectSpread(_objectSpread({}, s), {}, {
            cost: _objectSpread(_objectSpread({}, s.cost), {}, {
              discount: +value.amount ? DiscountModel.make(value.type, +value.amount) : null
            })
          }))
        })]
      });
    })(), discountedPrice && /*#__PURE__*/_jsxs(Typography, {
      "data-testid": testIds.ServiceRateModalContentTestIds.DiscountedPrice(),
      style: {
        marginTop: -4
      },
      children: ["Price after discount: ", discountedPrice]
    })]
  });
};